<template>
  <v-list flat class="bt-line group-list overflow-y-auto">
    <template>
      <v-list-item
        two-line
        v-for="(item, i) in searchList"
        :key="i"
        @click="selectItem(item.orgCd)"
        class="bb-line"
      >
        <v-list-item-content>
          <!-- 조직명 -->
          <v-list-item-title class="org-title">
            {{ item.orgNm }}
          </v-list-item-title>

          <!-- 조직경로(상위조직>하위조직>.. 순서) -->
          <v-list-item-subtitle class="org-path">
            {{ item.orgPath }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
/* 조직정보목록 컴포넌트 */
export default {
  props: {
    searchList: {
      type: Array,
    },
  },
  methods: {
    selectItem(orgCd) {
      // 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      this.$emit('selectItem', {
        searchOrgCd: orgCd,
      });
    },
  },
};
</script>

<style></style>
